import { InAppMessageAction } from "../../../../core/internal/model/model"
import { HackleInAppMessageLink } from "../../../../public/model"
import { InAppMessageActionConverter } from "../../InAppMessageConverter"
import { InAppMessageEventDto } from "../../../webapp/invocator/Invocation"
import { InAppMessageActionViewEvent, InAppMessageViewEvent } from "../event/InAppMessageViewEvent"

function toInAppMessageAction(url: string | HackleInAppMessageLink): InAppMessageAction {
  const link: HackleInAppMessageLink =
    typeof url === "string" ? { url, target: "CURRENT", shouldCloseAfterLink: true } : url
  return InAppMessageActionConverter.toInternal({ type: "LINK", link })
}

function createDefaultAction(): InAppMessageAction {
  return InAppMessageActionConverter.toInternal({ type: "LINK" })
}

export function toInAppMessageActionViewEvent({
  url,
  elementId,
  timestamp
}: {
  url?: string | HackleInAppMessageLink
  elementId?: string
  timestamp: number
}): InAppMessageActionViewEvent {
  return InAppMessageViewEvent.action({
    timestamp,
    action: url ? toInAppMessageAction(url) : createDefaultAction(),
    elementId
  })
}

export function toInAppMessageHiddenActionViewEvent({
  timestamp,
  hideDurationMillis
}: {
  timestamp: number
  hideDurationMillis: number
}): InAppMessageActionViewEvent {
  return InAppMessageViewEvent.action({
    timestamp,
    action: InAppMessageActionConverter.toInternal({ type: "CLOSE", close: { hideDurationMillis } })
  })
}

export function toInAppMessageActionEventDto({
  url,
  elementId
}: {
  url?: string | HackleInAppMessageLink
  elementId?: string
}): InAppMessageEventDto {
  const action = url ? toInAppMessageAction(url) : createDefaultAction()
  return {
    type: "ACTION",
    action: {
      behavior: action.behavior,
      type: action.type,
      value: action.value ?? null
    },
    element: {
      elementId
    }
  }
}

export function toInAppMessageHiddenEventDto(hideDurationMillis: number): InAppMessageEventDto {
  const action = InAppMessageActionConverter.toInternal({
    type: "CLOSE",
    close: { hideDurationMillis }
  })
  return {
    type: "ACTION",
    action: {
      behavior: action.behavior,
      type: action.type,
      value: action.value ?? null
    },
    element: {}
  }
}
